<template>
  <div>
    <p class="mb-1">
      {{ $t('errors.instruction_400.start') }}
      <a
        class="small red--text"
        :href="`mailto:${$t('errors.instruction_400.link')}`"
      >{{
        $t('errors.instruction_400.link')
      }}</a>
    </p>
    <p class="mb-0">
      {{ $t('errors.instruction_400.send') }}
    </p>
    <ul>
      <li
        v-for="(item, index) in $t('errors.instruction_400.list')"
        :key="index"
      >
        {{ item }}
      </li>
    </ul>
    <p class="mt-2 mb-0">
      {{ $t('errors.instruction_400.end') }}
    </p>
  </div>
</template>

<script>
export default {
    name: 'ErrorPage400'
};
</script>

<style scoped></style>
